'use client';

import { FC } from 'react';
import { useTranslations } from 'next-intl';
import styles from './StatsMapSection.module.scss';
const DOT_MARKERS = [{
  top: '38%',
  left: '18%'
}, {
  top: '34%',
  left: '22%'
}, {
  top: '42%',
  left: '15%'
}, {
  top: '28%',
  left: '48%'
}, {
  top: '32%',
  left: '52%'
}, {
  top: '36%',
  left: '46%'
}, {
  top: '40%',
  left: '55%'
}, {
  top: '30%',
  left: '72%'
}, {
  top: '44%',
  left: '68%'
}, {
  top: '35%',
  left: '75%'
}, {
  top: '50%',
  left: '78%'
}, {
  top: '55%',
  left: '20%'
}, {
  top: '60%',
  left: '50%'
}, {
  top: '48%',
  left: '30%'
}, {
  top: '26%',
  left: '60%'
}] as const;
const PULSING_INDICES = new Set([0, 3, 6, 9, 12]);
const StatsMapSection: FC = () => {
  const t = useTranslations();
  const STATS = [{
    value: '5,200+',
    label: t('statsMap.spaces')
  }, {
    value: '340+',
    label: t('statsMap.cities')
  }, {
    value: '68',
    label: t('statsMap.countries')
  }];
  return <section className={styles.section} data-sentry-component="StatsMapSection" data-sentry-source-file="StatsMapSection.tsx">
            <div className={styles.mapBackground}>
                <div className={styles.gradientOverlay} />

                {DOT_MARKERS.map((dot, index) => <span key={index} className={`${styles.dot} ${PULSING_INDICES.has(index) ? styles.dotPulsing : ''}`} style={{
        top: dot.top,
        left: dot.left
      }} />)}
            </div>

            <div className={styles.statsRow}>
                {STATS.map(stat => <div key={stat.label} className={styles.statCard}>
                        <span className={styles.statValue}>{stat.value}</span>
                        <span className={styles.statLabel}>{stat.label}</span>
                    </div>)}
            </div>
        </section>;
};
export default StatsMapSection;